import axios from "axios";
import {
  FETCH_GASTOS_REQUEST,
  FETCH_GASTOS_SUCCESS,
  FETCH_GASTOS_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionGastosGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_GASTOS_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/gastos", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_GASTOS_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar gastos";
    dispatch({ type: FETCH_GASTOS_FAILURE, payload: { error: msg } });
  }
};

export const apiGastosInstance = api;
export { authHeader as authHeaderGastos };
